import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { DISCOUNTS, IDENTIFIERS } from '../utils/constants';
import { formatPrice, formatPriceWithCode } from '../utils/helpers';

const OfferingCard = ({
  offer,
  selectedOffer,
  setSelectedOffer,
  isDiscount,
  identifier: urlIdentifier,
  showSinglePayment,
}) => {
  const { t } = useTranslation();
  const {
    identifier,
    rcBillingProduct: {
      currentPrice: { currency, amount },
    },
  } = offer;

  const isSelected = selectedOffer && selectedOffer.identifier === identifier;
  const isAnnual = offer.identifier === '$rc_annual';
  const title = isAnnual
    ? t('evieOnboarding.planScreen.offering.annual')
    : t('evieOnboarding.planScreen.offering.monthly');
  const discount = DISCOUNTS[urlIdentifier] || 1;

  const isFreeMonth = urlIdentifier === IDENTIFIERS.FREE_MONTH;

  return (
    <button
      type="button"
      onClick={() => setSelectedOffer(offer)}
      className={`${showSinglePayment ? 'single-payment__offeringcard' : 'plan-screen__offeringcard'} ${
        isSelected ? 'selected' : ''
      }`}
    >
      {((isAnnual && !isDiscount) || (isDiscount && isSelected)) && (
        <div className="offeringcard-top">
          <p>
            {isDiscount || isFreeMonth
              ? t(`evieOnboarding.planScreen.offering.${isFreeMonth ? 'freeMonthTrial' : 'trial'}`)
              : t('evieOnboarding.planScreen.offering.savingsChip')}
          </p>
        </div>
      )}
      <div className="offeringcard-mid">
        <div className={`plan-screen__offeringcard_trial ${!isDiscount && isSelected ? 'selected' : ''}`}>
          <span>{t(`evieOnboarding.planScreen.offering.${isFreeMonth ? 'freeMonthTrial' : 'trial'}`)}</span>
        </div>
        <div className="plan-screen__offeringcard_pricing">
          <span className={`radiobutton ${isSelected ? 'selected' : ''}`} />
          <p className="offering-price">
            {formatPrice(amount, currency, isAnnual)}
            <span className="offering-price-label">{t('evieOnboarding.planScreen.offering.perMonth')}</span>
          </p>
        </div>
        <div className="plan-screen__offeringcard_description">
          <p className="plan-screen__offeringcard_periodicity">{title}</p>
          {isAnnual ? (
            <p className="plan-screen__offeringcard_periodicity billed">
              {t('evieOnboarding.planScreen.offering.billed.annual', { price: formatPriceWithCode(amount, currency) })}
            </p>
          ) : (
            <p className="plan-screen__offeringcard_periodicity billed">
              {t('evieOnboarding.planScreen.offering.billed.monthly')}
            </p>
          )}
        </div>
      </div>
      <div className={`offeringcard-bottom ${isDiscount && isSelected ? 'selected' : ''}`}>
        {isDiscount ? (
          <p className="offeringcard-bottom_discount">
            {t('evieOnboarding.planScreen.offering.save', {
              amount: formatPrice((amount * (100 - discount)) / discount, currency),
            })}
          </p>
        ) : null}
        <p className="offeringcard-bottom_label">
          {t(`evieOnboarding.planScreen.offering.${isAnnual ? 'annualBonus' : 'monthlyAccess'}`)}
        </p>
      </div>
    </button>
  );
};

OfferingCard.defaultProps = {
  selectedOffer: null,
  isDiscount: false,
  identifier: null,
  showSinglePayment: false,
};

OfferingCard.propTypes = {
  offer: PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    rcBillingProduct: PropTypes.shape({
      currentPrice: PropTypes.shape({
        currency: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  selectedOffer: PropTypes.shape({
    identifier: PropTypes.string.isRequired,
  }),
  setSelectedOffer: PropTypes.func.isRequired,
  isDiscount: PropTypes.bool,
  identifier: PropTypes.string,
  showSinglePayment: PropTypes.bool,
};

export default OfferingCard;
